import React from 'react';
import TextInput from 'app/Components/Shared/TextInput/TextInput';

const FormField = ({
  name,
  type,
  placeholder,
  value,
  error,
  required,
  maxLength,
  onChange,
  disabled,
  options, // For select/dropdown
}) => {
  const handleChange = (e) => {
    onChange(e.target.value);
  };

  const inputId = `field-${name}`;

  // For select dropdown - style to match TextInput
  if (type === 'select') {
    const formControl = error ? 'input-error' : 'form-control';

    return (
      <label className={`has-float-${required ? 'label-required' : 'label'}`}>
        <select
          id={inputId}
          name={name}
          value={value}
          onChange={handleChange}
          disabled={disabled}
          className={formControl}
          aria-required={required}
          aria-invalid={!!error}
        >
          <option value=""></option>
          {options && options.map((option, index) => {
            // Handle both string options and {value, label} objects
            const optionValue = typeof option === 'string' ? option : option.value;
            const optionLabel = typeof option === 'string' ? option : option.label;

            return (
              <option key={index} value={optionValue}>
                {optionLabel}
              </option>
            );
          })}
        </select>
        <span className={error ? 'placeholder-error' : ''}>{placeholder}</span>
        {error && <div className='error'>{error}</div>}
      </label>
    );
  }

  // For text/tel/email/textarea inputs - use shared TextInput component
  return (
    <TextInput
      id={inputId}
      name={name}
      type={type}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled}
      maxLength={maxLength}
      required={required}
      error={error}
      rows={type === 'textarea' ? 4 : undefined}
    />
  );
};

export default FormField;

